import type React from 'react';

interface IProps extends React.PropsWithChildren {
  active?: boolean;
}

const Spinner: React.FC<IProps> = ({ active, children }) =>
  active ? <div className="progress-circle-indeterminate" /> : <>{children}</>;

export default Spinner;
